import { formatISO } from 'date-fns'
import { Draft } from 'immer'
import {
  PlanTimescale,
  StartMonthIndex,
  WeekStartsOn,
} from '@opallabs/concepts'
import { PlanResponse } from '../types'

type CategoryType = {
  id: string
  name: string
}

type UpdateableAttributes = {
  categoryType?: CategoryType | null
  timescale?: PlanTimescale
  title?: string
  endDate?: string
  startDate?: string
  startMonthIndex?: StartMonthIndex
  startWeekdayIndex?: WeekStartsOn
  showSmartSwimlaneDatasource?: boolean
  swimlaneTitleColumnWidth?: number
}

export const updateAttributes = ({
  categoryType,
  timescale,
  title,
  endDate,
  startDate,
  startMonthIndex,
  startWeekdayIndex,
  showSmartSwimlaneDatasource,
  swimlaneTitleColumnWidth,
}: UpdateableAttributes) => {
  return (draftResponse: Draft<PlanResponse>) => {
    if (timescale) draftResponse.data.settings.default_timescale = timescale
    if (title) draftResponse.data.title = title
    if (endDate) draftResponse.data.settings.end_at = formatISO(endDate)
    if (startDate) draftResponse.data.settings.start_at = formatISO(startDate)
    if (startMonthIndex)
      draftResponse.data.settings.start_month_index = startMonthIndex
    if (startWeekdayIndex) {
      draftResponse.data.settings.start_weekday_index = startWeekdayIndex
    }
    if (showSmartSwimlaneDatasource !== undefined) {
      draftResponse.data.settings.show_smart_swimlane_datasource =
        showSmartSwimlaneDatasource
    }
    if (swimlaneTitleColumnWidth !== undefined) {
      draftResponse.data.settings.swimlane_title_column_width =
        swimlaneTitleColumnWidth
    }

    if (categoryType) {
      draftResponse.data.settings.category_type = {
        ...categoryType,
        deactivated_at: null,
        description: null,
        supported_paired_type: null,
      }
    }
    if (categoryType === null) {
      draftResponse.data.settings.category_type = null
    }

    return draftResponse
  }
}
